export const categories = [
  {
    slug: "entertainment",
    name: "娱乐八卦",
    desc: "圈内动态与话题讨论的第一现场",
    icon: "ri-sparkling-2-line",
    accent: "primary",
  },
  {
    slug: "screen",
    name: "影视综艺",
    desc: "剧集、电影、综艺的口碑风向标",
    icon: "ri-film-line",
    accent: "accent",
  },
  {
    slug: "streamer",
    name: "网红主播",
    desc: "直播间里正在发生的高能时刻",
    icon: "ri-live-line",
    accent: "secondary",
  },
  {
    slug: "music",
    name: "音乐现场",
    desc: "新歌、巡演与音乐节速报",
    icon: "ri-music-2-line",
    accent: "primary",
  },
  {
    slug: "esports",
    name: "游戏电竞",
    desc: "赛事战报与选手动向一网打尽",
    icon: "ri-gamepad-line",
    accent: "secondary",
  },
  {
    slug: "sports",
    name: "体育赛事",
    desc: "比分、转会与场外话题",
    icon: "ri-basketball-line",
    accent: "accent",
  },
  {
    slug: "tech",
    name: "科技数码",
    desc: "新品发布与行业趋势速览",
    icon: "ri-smartphone-line",
    accent: "primary",
  },
  {
    slug: "lifestyle",
    name: "时尚生活",
    desc: "穿搭、街拍与年轻生活方式",
    icon: "ri-t-shirt-line",
    accent: "secondary",
  },
];

export const kuaibaoList = [
  {
    slug: "summer-music-festival-lineup",
    title: "夏日音乐节完整阵容公布，多组实力歌手同台",
    summary: "主办方一次性放出三天的演出名单，独立乐队与流行唱将混搭编排，观众直呼排期太满挑不过来。",
    category: "音乐现场",
    categorySlug: "music",
    heat: 98200,
    tags: ["音乐节", "演出阵容", "现场"],
    publishedAt: "2026-09-12 09:10",
    cover: "https://readdy.ai/api/search-image?query=abstract%20editorial%20collage%20of%20a%20summer%20music%20festival%20stage%20with%20warm%20amber%20light%20beams%20and%20cream%20paper%20texture%2C%20artistic%20grainy%20gradient%2C%20high%20contrast%2C%20magazine%20cover%20style&width=800&height=500&seq=gua-music-festival-01&orientation=landscape",
    content: [
      "就在刚刚，夏日音乐节的主办方终于放出了完整的三日演出阵容。和往年只公布头部名字不同，这一次直接把每个舞台的排期表一次性摊开，让不少等消息的歌迷当场开始做选择困难题。",
      "从名单来看，今年的编排明显更强调「混搭」。独立乐队被安排在傍晚的露天主舞台，而几组流行唱将则压轴夜间场次，主办方解释是希望观众能在一天之内体验不同质感的现场。",
      "值得注意的是，多组此前从未同台的音乐人也出现在同一时段的不同舞台，社交平台上已经有人开始规划「赶场路线」，并自发整理出最省时的移动方案。",
      "票务方面，主办方表示仍在分批次放票，并提醒观众留意官方渠道，避免因第三方加价而多花冤枉钱。完整的交通与入场指引将在临近演出前一周同步更新。",
    ],
  },
  {
    slug: "reality-show-new-season",
    title: "王牌综艺全新一季开播，赛制升级引发讨论",
    summary: "首期上线后，全新的组队与淘汰机制成为弹幕焦点，有人觉得刺激，也有人担心节奏过快。",
    category: "影视综艺",
    categorySlug: "screen",
    heat: 91500,
    tags: ["综艺", "开播", "赛制"],
    publishedAt: "2026-09-12 08:40",
    cover: "https://readdy.ai/api/search-image?query=abstract%20editorial%20collage%20of%20a%20television%20variety%20show%20set%20with%20warm%20coral%20spotlights%20and%20cream%20beige%20paper%20texture%2C%20artistic%20grain%2C%20bold%20graphic%20shapes%2C%20magazine%20cover%20style&width=800&height=500&seq=gua-variety-show-02&orientation=landscape",
    content: [
      "期待已久的王牌综艺终于开播。相比上一季，新一季最大的变化是把原本的固定队伍打散，改成每期重新抽签组队，这也意味着没有谁能一直躺赢。",
      "首期节目上线两个小时，相关话题就冲上了讨论榜。支持的人认为新赛制让每个人都有表现机会，反对的声音则觉得临时组队削弱了磨合带来的默契感。",
      "节目组在采访中回应，赛制调整的核心是希望把镜头更多留给真实反应，而不是设计好的剧本。至于效果如何，还要看后续几期的口碑走向。",
      "目前节目保持每周更新一期的节奏，平台也同步上线了花絮合集，方便只想快速了解看点的观众在几分钟内补完当期的关键片段。",
    ],
  },
  {
    slug: "web-celebrity-livestream-record",
    title: "头部主播单场直播观看破千万，带货数据再刷新",
    summary: "一场持续六小时的直播里，多个单品在开链接后瞬间售罄，围观人数一度挤爆评论区。",
    category: "网红主播",
    categorySlug: "streamer",
    heat: 87600,
    tags: ["直播", "带货", "数据"],
    publishedAt: "2026-09-11 22:15",
    cover: "https://readdy.ai/api/search-image?query=abstract%20editorial%20collage%20of%20a%20livestream%20studio%20with%20warm%20amber%20ring%20lights%20and%20olive%20green%20accents%20on%20cream%20paper%2C%20artistic%20grain%20texture%2C%20graphic%20composition%2C%20magazine%20style&width=800&height=500&seq=gua-livestream-03&orientation=landscape",
    content: [
      "昨晚的直播从八点一直持续到凌晨，六个小时里在线人数几乎没有掉下过七位数。开播不到十分钟，评论区就已经被刷到看不清具体内容。",
      "和以往主打低价不同，这一场把重心放在了选品讲解上，主播花了大量时间拆解材质和使用场景，也正因为节奏偏慢，反而让不少观众留了下来。",
      "数据显示，多个单品在开链接的瞬间就被抢空，后台不得不临时追加库存。有从业者分析，这种「慢讲解」的路线正在成为新的流量密码。",
      "不过也有观众提醒，热闹之余还是要按自己的需求下单，避免被现场氛围带着冲动消费。",
    ],
  },
  {
    slug: "esports-world-final",
    title: "电竞世界赛总决赛落幕，黑马战队逆转夺冠",
    summary: "决胜局一度落后近万经济，最终凭借一波团战翻盘，现场与直播间的情绪同时被点燃。",
    category: "游戏电竞",
    categorySlug: "esports",
    heat: 94300,
    tags: ["电竞", "总决赛", "逆转"],
    publishedAt: "2026-09-11 21:05",
    cover: "https://readdy.ai/api/search-image?query=abstract%20editorial%20collage%20of%20an%20esports%20arena%20with%20warm%20coral%20and%20amber%20lighting%20on%20cream%20paper%20texture%2C%20artistic%20grain%2C%20graphic%20geometric%20shapes%2C%20magazine%20cover%20style&width=800&height=500&seq=gua-esports-final-04&orientation=landscape",
    content: [
      "世界赛总决赛在昨晚迎来收官。赛前几乎没有人看好这支从小组赛惊险出线的队伍，但他们在决胜局用一波教科书级别的团战完成了翻盘。",
      "决胜局前半段，这支队伍一度在经济上落后接近一万，弹幕里「没了」的声音此起彼伏。转折点出现在中期的关键资源争夺，他们用一次极限的换线抓住了对手的失误。",
      "赛后采访中，队长把胜利归给了团队的沟通，坦言赛前压力大到几乎没睡好。现场的欢呼声持续了近一分钟，直播间的同时在线也创下了今晚的新高。",
      "随着冠军诞生，关于阵容续约与选手转会的话题也开始升温，接下来几周料将有不少新动向。",
    ],
  },
  {
    slug: "film-box-office-weekend",
    title: "周末票房榜出炉，现实题材新片口碑领跑",
    summary: "一部小成本现实题材作品凭借扎实的故事逆势上扬，排片占比几天内翻了一倍多。",
    category: "影视综艺",
    categorySlug: "screen",
    heat: 78900,
    tags: ["票房", "电影", "口碑"],
    publishedAt: "2026-09-11 18:30",
    cover: "https://readdy.ai/api/search-image?query=abstract%20editorial%20collage%20of%20a%20cinema%20screen%20glow%20with%20warm%20amber%20and%20cream%20palette%2C%20artistic%20grain%20texture%2C%20minimal%20graphic%20composition%2C%20magazine%20cover%20style&width=800&height=500&seq=gua-box-office-05&orientation=landscape",
    content: [
      "本周末的票房榜出现了一个不小的意外：一部并没有大牌阵容的现实题材影片，凭借口口相传爬到了榜单前列。",
      "影片讲的是普通人的日常困境，没有夸张的戏剧冲突，却因为细节真实而被大量观众自发推荐。上映第三天，它的排片占比已经比首日翻了一倍多。",
      "院线经理透露，这类作品往往首日不占优势，但如果上座率稳定，就很容易拿到更多场次。这次的情形正是如此。",
      "与此同时，几部投入更大的商业片表现中规中矩，这也让业内再次讨论起「口碑驱动排片」的变化趋势。",
    ],
  },
  {
    slug: "celebrity-wedding-rumor",
    title: "圈内情侣被拍同框，工作室回应引发全网猜测",
    summary: "一组路透照片在深夜流出，双方工作室口径不一致，话题阅读量短时间内持续攀升。",
    category: "娱乐八卦",
    categorySlug: "entertainment",
    heat: 89700,
    tags: ["话题", "回应", "热榜"],
    publishedAt: "2026-09-11 15:50",
    cover: "https://readdy.ai/api/search-image?query=abstract%20editorial%20collage%20of%20soft%20warm%20coral%20and%20cream%20paper%20with%20subtle%20spotlight%20shapes%2C%20artistic%20grain%2C%20minimal%20geometric%20composition%2C%20magazine%20cover%20style&width=800&height=500&seq=gua-celebrity-rumor-06&orientation=landscape",
    content: [
      "一组在深夜流出的路透照片，让两位长期被猜测的艺人再次站上了话题中心。照片中两人出现在同一场合，打扮低调，并没有刻意的互动动作。",
      "真正让讨论升温的，是随后双方工作室对外口径上的细微差别。一方措辞偏保守，另一方则明显更松弛，这种不一致被解读出了各种版本。",
      "截至发稿，相关话题的阅读量仍在持续攀升。不少理智的网友表示，艺人也有自己的私人空间，在没有确凿信息之前，不妨给当事人多一些余地。",
      "无论真相如何，这类事件的规律都很相似：先是一张照片，接着是各种解读，最后往往要等当事人自己开口，才会有一个相对清晰的答案。",
    ],
  },
  {
    slug: "idol-group-comeback",
    title: "人气组合宣布回归，先行曲上线即登顶热榜",
    summary: "时隔一年多再发新作，先行曲没有走熟悉的路线，反而选择了更克制的编曲。",
    category: "音乐现场",
    categorySlug: "music",
    heat: 83200,
    tags: ["回归", "新歌", "热榜"],
    publishedAt: "2026-09-11 12:20",
    cover: "https://readdy.ai/api/search-image?query=abstract%20editorial%20collage%20of%20warm%20amber%20sound%20wave%20shapes%20on%20cream%20paper%20texture%2C%20artistic%20grain%2C%20minimal%20graphic%20composition%2C%20magazine%20cover%20style&width=800&height=500&seq=gua-comeback-07&orientation=landscape",
    content: [
      "人气组合在沉寂了一年多之后正式宣布回归，先行曲在上线后不久就冲到了热榜前列。",
      "让歌迷意外的是，这次没有延续以往强烈的舞曲路线，编曲反而更克制，把人声和情绪放在了更靠前的位置。有人形容是「把舞台让给了嗓音」。",
      "官方同步放出的概念短片也延续了这种克制，没有复杂的视觉特效，而是用长镜头记录了几段安静的日常片段。",
      "据透露，完整的专辑将在下个月发行，随后还会安排巡演。先行曲只是一个开始，真正的重头戏还在后面。",
    ],
  },
  {
    slug: "sports-transfer-news",
    title: "转会窗口关闭前夜，多笔重磅交易尘埃落定",
    summary: "截止日当天连爆数条官宣，涉及多名核心球员，几支球队的阵容结构因此被彻底改写。",
    category: "体育赛事",
    categorySlug: "sports",
    heat: 75600,
    tags: ["转会", "联赛", "官宣"],
    publishedAt: "2026-09-10 23:40",
    cover: "https://readdy.ai/api/search-image?query=abstract%20editorial%20collage%20of%20a%20stadium%20at%20dusk%20with%20warm%20amber%20lights%20on%20cream%20paper%20texture%2C%20artistic%20grain%2C%20bold%20graphic%20composition%2C%20magazine%20cover%20style&width=800&height=500&seq=gua-transfer-08&orientation=landscape",
    content: [
      "转会窗口在深夜正式关闭，而紧挨着截止时间的那几个小时，反而是整个夏天消息最密集的时段。",
      "多支球队在同一晚先后官宣了新援，其中几笔交易此前几乎没有风声，属于典型的「忽然落地」。有球队用一笔引援直接补上了长期存在的短板。",
      "也有球队选择了相反的方向，把队内的高薪球员送走，换来更灵活的薪资空间。这种取舍在短期成绩与长期建队之间的平衡，向来是最考验管理层的部分。",
      "随着注册手续陆续完成，新阵容将在接下来的比赛中接受检验，真正的答案往往要等几轮之后才会浮现。",
    ],
  },
  {
    slug: "tech-flagship-launch",
    title: "新一代旗舰机型发布，影像与续航成最大亮点",
    summary: "发布会没有堆砌参数，而是把大部分时间留给了实际拍摄样张与续航测试场景。",
    category: "科技数码",
    categorySlug: "tech",
    heat: 71400,
    tags: ["新品", "影像", "续航"],
    publishedAt: "2026-09-10 20:10",
    cover: "https://readdy.ai/api/search-image?query=abstract%20editorial%20collage%20of%20a%20sleek%20smartphone%20silhouette%20with%20warm%20amber%20and%20coral%20gradient%20on%20cream%20paper%20texture%2C%20artistic%20grain%2C%20minimal%20graphic%20composition%2C%20magazine%20cover%20style&width=800&height=500&seq=gua-tech-launch-09&orientation=landscape",
    content: [
      "新一代旗舰机型在昨晚正式亮相。和常见的长篇参数发布不同，这场发布会把大量时间留给了样张与实测场景。",
      "影像依旧是主打的卖点之一，官方重点演示了弱光环境下的成像表现，强调在保留细节的同时减少涂抹感。现场展示的对比样张也确实能看出差别。",
      "续航方面，机身厚度并没有明显增加，但官方给出的日常使用时长有了不小提升，并提出了一套更激进的充电策略。",
      "价格与开售时间同步公布，首批备货据称比上一代更充足。至于实际体验能否匹配宣传，还要等首批用户的反馈。",
    ],
  },
  {
    slug: "fashion-week-street-style",
    title: "时装周街拍合集，复古穿搭成最大赢家",
    summary: "这一季场外的街拍比秀场还热闹，低饱和色调和宽松剪裁几乎成了统一语言。",
    category: "时尚生活",
    categorySlug: "lifestyle",
    heat: 63800,
    tags: ["时装周", "街拍", "穿搭"],
    publishedAt: "2026-09-10 16:05",
    cover: "https://readdy.ai/api/search-image?query=abstract%20editorial%20collage%20of%20autumn%20street%20style%20silhouettes%20with%20warm%20olive%20amber%20and%20cream%20palette%2C%20artistic%20grain%20texture%2C%20minimal%20graphic%20composition%2C%20magazine%20cover%20style&width=800&height=500&seq=gua-fashion-week-10&orientation=landscape",
    content: [
      "每逢时装周，场外的街拍往往比秀场本身更有讨论度。这一季也不例外，摄影师们几乎把镜头对准了同一批关键词。",
      "从流出的画面看，低饱和的大地色系占据了绝对多数，棕、米、橄榄绿被反复使用，搭配上也更强调宽松与层次，而不是紧绷的线条。",
      "值得注意的是，配饰的比重明显上升。一条颜色跳脱的围巾或一只造型利落的手袋，往往就是整套造型的点睛之笔。",
      "有造型师总结，这一季的流行并不在于买了什么新款，而在于如何把衣柜里已有的单品重新组合出松弛感。",
    ],
  },
  {
    slug: "variety-show-guest-list",
    title: "慢综艺官宣常驻名单，治愈系风格未播先火",
    summary: "没有任务、没有比赛，节目组只公布了常驻嘉宾和一间山间小院，预告片却已经刷屏。",
    category: "影视综艺",
    categorySlug: "screen",
    heat: 68200,
    tags: ["慢综艺", "官宣", "治愈"],
    publishedAt: "2026-09-10 11:35",
    cover: "https://readdy.ai/api/search-image?query=abstract%20editorial%20collage%20of%20a%20quiet%20mountain%20courtyard%20with%20warm%20amber%20sunlight%20and%20cream%20paper%20texture%2C%20artistic%20grain%2C%20soft%20minimal%20graphic%20composition%2C%20magazine%20cover%20style&width=800&height=500&seq=gua-slow-variety-11&orientation=landscape",
    content: [
      "一档主打治愈的慢综艺正式公布了常驻名单，嘉宾的组合跨度不小，既有熟面孔，也有很少参加综艺的演员。",
      "节目组同时放出的预告片里，几乎没有设置任何任务或比赛，画面就是几个人在小院里做饭、聊天、发呆，配上环境音，反而显得格外松弛。",
      "这种「什么都不做」的设定恰恰戳中了不少人的需求。有观众留言说，看惯了强节奏的竞技类节目，反而想在这种慢下来的内容里喘口气。",
      "节目尚未开播，相关话题的讨论量已经相当可观。能否把「治愈」一直保持到最后，而不是中途加戏，将是它口碑的关键。",
    ],
  },
  {
    slug: "short-drama-trend",
    title: "短剧赛道再出爆款，竖屏叙事成新风口",
    summary: "一部每集只有几分钟的作品意外出圈，紧凑的节奏与高密度的反转成为讨论重点。",
    category: "娱乐八卦",
    categorySlug: "entertainment",
    heat: 66100,
    tags: ["短剧", "内容", "趋势"],
    publishedAt: "2026-09-09 21:50",
    cover: "https://readdy.ai/api/search-image?query=abstract%20editorial%20collage%20of%20vertical%20screen%20frames%20with%20warm%20coral%20amber%20and%20cream%20palette%2C%20artistic%20grain%20texture%2C%20graphic%20geometric%20composition%2C%20magazine%20cover%20style&width=800&height=500&seq=gua-short-drama-12&orientation=landscape",
    content: [
      "短剧赛道最近又冒出了一部话题作品。每集只有几分钟，却靠着紧凑的节奏和高密度的反转，让不少原本并不看短剧的人入了坑。",
      "和长剧相比，这类内容的叙事更依赖「钩子」，几乎每一集结尾都要留下一个必须点开下一集的理由。这种结构天然适合在通勤、排队的碎片时间里观看。",
      "从业者认为，竖屏叙事的成熟正在改变内容的制作逻辑：镜头更近、信息更密集、留给铺垫的空间更少，对剧本和表演的要求反而更高。",
      "当然，热度之外也有隐忧。如何在快节奏和故事深度之间找到平衡，避免题材同质化，是这个赛道接下来要面对的问题。",
    ],
  },
];

export const hotTags = [
  "夏日音乐节阵容",
  "综艺赛制升级",
  "电竞逆转夺冠",
  "周末票房口碑",
  "直播带货数据",
  "短剧新风口",
  "转会截止日",
  "旗舰新机发布",
  "时装周街拍",
  "慢综艺治愈",
];

export const faqs = [
  {
    q: "「今日吃瓜单」和普通的资讯列表有什么不同？",
    a: "我们把每天的热点先做一次筛选与排序，再压缩成一句话摘要和一分钟能读完的速览。你不需要在多个平台之间来回切换，打开一页就能掌握今天的重点。",
  },
  {
    q: "一分钟真的能刷完全部热点吗？",
    a: "速览模式把每条快报的核心信息放在最显眼的位置，配合热度榜排序，你可以只看前十名就把当天最值得关注的事看完。想深入了解时，再点进详情页阅读完整内容。",
  },
  {
    q: "内容大概多久更新一次？",
    a: "热点集中出现的时段，快报会保持较高频次的滚动更新；相对平静的时间段，也会在每天固定的早、中、晚三个时间点各做一次汇总，保证你打开时总有新内容。",
  },
  {
    q: "看到的快报中有不准确的地方怎么办？",
    a: "欢迎通过页面底部的联系渠道反馈。我们会在收到信息后尽快核对，确认有误的部分会及时修订，并在条目上标注更新记录，做到可追溯。",
  },
  {
    q: "可以只看自己感兴趣的分类吗？",
    a: "可以。在吃瓜快报列表页提供按分类筛选和关键词搜索，你可以只看娱乐、影视、电竞等自己关心的板块，也可以直接搜索具体话题名称。",
  },
];

export const testimonials = [
  {
    name: "阿哲",
    role: "通勤党",
    text: "以前每天早上要刷好几个平台，现在看一页瓜单就够了，地铁上两站路就能跟上进度。",
  },
  {
    name: "小鹿",
    role: "剧综爱好者",
    text: "分类特别清楚，我只订阅了影视和综艺，再也不用被一堆不感兴趣的内容刷屏。",
  },
  {
    name: "老陈",
    role: "内容从业者",
    text: "排序做得挺克制，没有为了博眼球把小事放大。想快速了解舆论走向时会来这里看。",
  },
];